import AccountTreeIcon from '@material-ui/icons/AccountTree';
import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';

const rootRouteRef = createRouteRef();

const informationFlowPage = PageBlueprint.make({
  params: {
    path: '/information-flow',
    title: 'Information Flow',
    icon: <AccountTreeIcon />,
    routeRef: rootRouteRef,
    loader: () =>
      import('./InformationFlowPage').then(module => (
        <module.InformationFlowPage />
      )),
  },
});

export const informationFlowPlugin = createFrontendPlugin({
  pluginId: 'information-flow',
  title: 'Information Flow',
  icon: <AccountTreeIcon />,
  routes: { root: rootRouteRef },
  extensions: [informationFlowPage],
});
